import React from "react";
import { CheckSquare, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PackersToolbarProps {
  total: number;
  packedToday: number;
  selectedCount: number;
  onSelectAll: () => void;
  onPrintSelected: () => void;
  onPrintNew: () => void;
  isPrinting: boolean;
}

const PackersToolbar = ({
  total,
  packedToday,
  selectedCount,
  onSelectAll,
  onPrintSelected,
  onPrintNew,
  isPrinting,
}: PackersToolbarProps) => {
  return (
    <div className="flex items-center justify-between flex-wrap gap-3">
      <div className="flex items-center gap-3">
        <span className="bg-white/10 text-white px-3 py-1.5 rounded-full text-sm font-medium">
          {total} beschikbaar
        </span>
        <span className="bg-emerald-500/20 text-emerald-300 px-3 py-1.5 rounded-full text-sm font-medium">
          {packedToday} ingepakt vandaag
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onSelectAll}
          className="bg-white/10 border-white/20 text-white hover:bg-white/20"
        >
          <CheckSquare className="w-4 h-4 mr-1" />
          Selecteer alle
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onPrintSelected}
          disabled={selectedCount === 0 || isPrinting}
          className="bg-white/10 border-white/20 text-white hover:bg-white/20"
        >
          <Printer className="w-4 h-4 mr-1" />
          Print etiketten ({selectedCount})
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onPrintNew}
          disabled={isPrinting}
          className="bg-blue-500/20 border-blue-400/30 text-blue-200 hover:bg-blue-500/30"
        >
          <Printer className="w-4 h-4 mr-1" />
          Print nieuwe
        </Button>
      </div>
    </div>
  );
};

export default PackersToolbar;
